(() => {
  const modal = document.getElementById('cartModal');
  if (!modal || window.EmasexCart) return;
  const status = modal.querySelector('[data-cart-status]');
  const text = CART_DRAWER_TEXT;
  const root = window.Shopify.routes.root;
  let tail = Promise.resolve();
  let pending = 0;
  let returnFocus = null;
  let previousOpen = false;
  let inertElements = [];
  let onCartRoute = window.location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, '');

  function error() {
    status.textContent = text.error;
    status.setAttribute('data-error', '');
  }

  function busy(value) {
    modal.setAttribute('aria-busy', String(value));
    status.toggleAttribute('data-loading', value);
    const express = modal.querySelector('[data-express-wrap]');
    if (express) express.inert = value;
    modal.querySelectorAll('button, input, select').forEach(element => {
      if (element.classList.contains('cart-modal__close')) return;
      if (value) {
        if (!element.disabled) { element.dataset.cartWasEnabled = ''; element.disabled = true; }
      } else if ('cartWasEnabled' in element.dataset) {
        element.disabled = false;
        delete element.dataset.cartWasEnabled;
      }
    });
  }

  function run(operation) {
    pending++;
    invalidateShipping();
    busy(true);
    status.removeAttribute('data-error');
    status.textContent = text.loading;
    const result = tail.then(operation);
    const completion = result.catch(error).finally(() => {
      pending--;
      if (!pending) {
        busy(false);
        if (!status.hasAttribute('data-error')) {
          status.textContent = text.updated;
          if (currentCart) shipping(currentCart);
        } else {
          shippingValue.textContent = 'An der Kasse prüfen';
        }
      }
    });
    tail = completion;
    return completion;
  }

  const rulesElement = modal.querySelector('[data-cart-shipping-rules]');
  const shippingRules = JSON.parse(rulesElement.textContent);
  const country = rulesElement.dataset.country;
  let currentCart = null;
  const shippingValue = modal.querySelector('#cart-summary-shipping-value');
  const shippingLabel = modal.querySelector('#cart-summary-shipping-label');
  const totalValue = modal.querySelector('#cart-summary-total-value');
  const totalLabel = modal.querySelector('#cart-summary-total-label');

  function invalidateShipping() {
    shippingValue.textContent = 'Wird aktualisiert …';
    totalLabel.textContent = 'Zwischensumme';
    if (currentCart) totalValue.textContent = window.formatMoney(currentCart.total_price);
  }

  function shipping(cart) {
    const rule = shippingRules.countries[country];
    const verified = rule && cart.currency === shippingRules.currency && cart.items.every(item => shippingRules.handles.includes(item.handle));
    shippingLabel.textContent = 'Standardversand';
    totalValue.textContent = window.formatMoney(cart.total_price);
    totalLabel.textContent = 'Zwischensumme';
    modal.querySelector('[data-cart-shipping-banner]').textContent = verified ? 'Standard: ' + window.formatMoney(rule.price) + ' · ab ' + window.formatMoney(rule.freeFrom) + ' kostenlos' : 'Versandkosten an der Kasse';
    if (!cart.requires_shipping) {
      shippingValue.textContent = 'Kostenlos';
      totalLabel.textContent = 'Gesamt';
    } else if (verified) {
      const amount = cart.total_price >= rule.freeFrom ? 0 : rule.price;
      shippingValue.textContent = amount ? window.formatMoney(amount) : 'Kostenlos';
      totalValue.textContent = window.formatMoney(cart.total_price + amount);
      totalLabel.textContent = 'Gesamt (geschätzt)';
    } else {
      shippingValue.textContent = 'An der Kasse';
    }
  }

  function summary(cart) {
    currentCart = cart;
    modal.querySelector('#cart-summary-subtotal-value').textContent = window.formatMoney(cart.original_total_price);
    totalValue.textContent = window.formatMoney(cart.total_price);
    const codes = (cart.discount_codes || []).filter(code => code.applicable !== false).map(code => code.code);
    const discount = modal.querySelector('#cart-discount-tag');
    discount.style.display = cart.total_discount > 0 ? 'flex' : 'none';
    modal.querySelector('#cart-discount-tag-code').textContent = codes.length ? '(' + codes.join(', ') + ')' : '';
    modal.querySelector('#cart-discount-tag-amount').textContent = '−' + window.formatMoney(cart.total_discount || 0);
    modal.querySelector('#cart-discount-tag-remove').hidden = !codes.length;
    if (!pending) shipping(cart);
  }
  modal.querySelector('#cart-checkout-form').addEventListener('submit', checkout);

  function lifecycle() {
    const isOpen = modal.classList.contains('active');
    if (isOpen === previousOpen) return;
    previousOpen = isOpen;
    modal.setAttribute('aria-hidden', String(!isOpen));
    document.documentElement.classList.toggle('has-cart-drawer', isOpen);
    if (isOpen) {
      returnFocus = document.activeElement;
      if (!modal.open) modal.showModal();
      let ancestor = modal;
      while (ancestor.parentElement && ancestor !== document.body) {
        for (const sibling of ancestor.parentElement.children) {
          if (sibling !== ancestor && sibling instanceof HTMLElement && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
            inertElements.push([sibling, sibling.inert]);
            sibling.inert = true;
          }
        }
        ancestor = ancestor.parentElement;
      }
      modal.querySelector('.cart-modal__close').focus();
      if (!onCartRoute) {
        try { sessionStorage.setItem('emasex_cart_return', window.location.pathname + window.location.search); } catch {}
      }
      run(() => window.loadCartItems());
    } else {
      if (modal.open) modal.close();
      for (const [element, previous] of inertElements) element.inert = previous;
      inertElements = [];
      if (returnFocus?.isConnected && !returnFocus.closest('[data-cart-page]')) returnFocus.focus();
      if (onCartRoute) {
        onCartRoute = false;
        window.location.assign(root + 'collections/all');
      }
    }
  }

  function open() { modal.classList.add('active'); lifecycle(); }
  function close() { modal.classList.remove('active'); lifecycle(); }
  function toggle() { modal.classList.contains('active') ? close() : open(); }

  function change(key, quantity) {
    quantity = Number(quantity);
    if (!Number.isInteger(quantity) || quantity < 0) { error(); return Promise.resolve(); }
    const active = document.activeElement;
    const variant = active?.closest('[data-variant-id]')?.dataset.variantId;
    const control = active?.dataset.cartControl;
    return run(async () => {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      await window.loadCartItems();
      await window.updateBundleDiscountNotice?.();
    }).then(() => {
      if (previousOpen && variant && control) {
        const line = Array.from(modal.querySelectorAll('[data-variant-id]')).find(item => item.dataset.variantId === variant);
        line?.querySelector('[data-cart-control="' + control + '"]')?.focus();
      }
    });
  }

  async function checkout(event) {
    event?.preventDefault();
    await tail;
    if (pending || status.hasAttribute('data-error')) return;
    const response = await fetch(root + 'cart.js').catch(() => null);
    if (!response?.ok) return error();
    const cart = await response.json();
    if (!cart.item_count) { await window.loadCartItems(); return; }
    const url = new URL(root + 'checkout', window.location.origin);
    url.searchParams.set('locale', 'de');
    const bundle = sessionStorage.getItem('bundle_discount');
    const hasLibo = cart.items.some(item => (item.handle || '').includes('libo'));
    const hasArginin = cart.items.some(item => (item.handle || '').includes('arginin'));
    if (bundle && hasLibo && hasArginin) url.searchParams.set('discount', bundle);
    window.location.assign(url.href);
  }

  window.EmasexCart = { open, close, toggle, change, run, checkout, error, summary };
  modal.addEventListener('cancel', event => { event.preventDefault(); close(); });
  new MutationObserver(lifecycle).observe(modal, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('cart:updated', event => {
    status.removeAttribute('data-error');
    if (!pending) status.textContent = '';
    const count = document.querySelector('.cart-count');
    if (count) { count.textContent = event.detail.item_count; count.style.display = event.detail.item_count ? 'flex' : 'none'; }
    if (pending) busy(true);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, '') && !url.search) {
      event.preventDefault(); open();
    }
  });
  document.addEventListener('keydown', event => {
    if (!previousOpen) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }

  });
  window.addEventListener('pageshow', event => { if (event.persisted && previousOpen) window.loadCartItems(); });
  if (onCartRoute) {
    document.documentElement.classList.add('cart-drawer-mode');
    let previous = root + 'collections/all';
    try { previous = sessionStorage.getItem('emasex_cart_return') || previous; } catch {}
    const destination = new URL(previous, window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.startsWith(root) || /\/(cart|checkout|checkouts)(\/|$)/.test(destination.pathname)) {
      destination.href = new URL(root + 'collections/all', window.location.origin).href;
    }
    destination.searchParams.set('cart_drawer', 'open');
    window.location.replace(destination.href);
  } else {
    const url = new URL(window.location.href);
    if (url.searchParams.get('cart_drawer') === 'open') {
      url.searchParams.delete('cart_drawer');
      window.history.replaceState(window.history.state, '', url.href);
      open();
    } else lifecycle();
  }
})();
